export default {
  '400': 'There was an error in validating.',
  '401': 'Your session expired.',
  '412': 'Operation cannot be completed.',
  '403': 'You are not authorized',
  '404': 'Requested resource does not exist.',
  '407': 'You need to configure your Proxy to use the system.',
  '408': 'Server is not responding. Try later.',
  '409': 'Invalid data',
  '410': 'Requested resource is not and will not be available.',
  '500': 'There was an error communicating with the server, Try later.',
  '502': 'System is not available at the moment. Try later.',
  '503': 'System currently undergoing maintenance. Try later please.',
  // '504': 'Gateway timeout - Tiempo de espera agotado.', // Esto debe ser implementado en el frontend para reintentar las peticiones
  'connection': 'Cannot communicate with the server.',
  'cancelRequest': 'Request was canceled',
  'validation': 'Validation error',
  'unknown': 'An unknown error occurred, try later.',
  'sessionExpired': 'Your session has expired, login again.'
};



// WEBPACK FOOTER //
// ./src/common/lang/en/errors.js